var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargeback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.3335C0 11.0787 10.7452 0.333496 24 0.333496C37.2548 0.333496 48 11.0787 48 24.3335C48 37.5883 37.2548 48.3335 24 48.3335C10.7452 48.3335 0 37.5883 0 24.3335Z",
    fill: "#ECF3F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.89 23.4335C23.11 22.8435 22.25 22.4735 22.25 21.5335C22.25 20.5135 23.36 20.1435 24.06 20.1435C25.37 20.1435 25.85 21.1335 25.96 21.4835L27.54 20.8135C27.39 20.3635 26.72 18.8935 25 18.5735V17.3335H23V18.5935C20.52 19.1535 20.51 21.4535 20.51 21.5535C20.51 23.8235 22.76 24.4635 23.86 24.8635C25.44 25.4235 26.14 25.9335 26.14 26.8935C26.14 28.0235 25.09 28.5035 24.16 28.5035C22.34 28.5035 21.82 26.6335 21.76 26.4135L20.1 27.0835C20.73 29.2735 22.38 29.8635 23 30.0435V31.3335H25V30.0935C25.4 30.0035 27.9 29.5035 27.9 26.8735C27.9 25.4835 27.29 24.2635 24.89 23.4335ZM15 33.3335H13V27.3335H19V29.3335H16.52C18.13 31.7435 20.88 33.3335 24 33.3335C28.97 33.3335 33 29.3035 33 24.3335H35C35 30.4135 30.08 35.3335 24 35.3335C20.28 35.3335 16.99 33.4835 15 30.6635V33.3335ZM13 24.3335C13 18.2535 17.92 13.3335 24 13.3335C27.72 13.3335 31.01 15.1835 33 18.0035V15.3335H35V21.3335H29V19.3335H31.48C29.87 16.9235 27.12 15.3335 24 15.3335C19.03 15.3335 15 19.3635 15 24.3335H13Z",
    fill: "#1D7CBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeback);
export default __webpack_public_path__ + "static/media/chargeback.15a04830acffb146ca3a678b5006803d.svg";
export { ForwardRef as ReactComponent };